// Write your JS code here
import './index.css'

const UserInfo = () => (
  <div className="user-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/profile-img.png"
      alt="profile"
      className="profile"
    />
    <h1 className="person-name">Wade Warren</h1>
    <p className="description">Software developer at UK</p>
  </div>
)

export default UserInfo
